import React, { useEffect, useMemo, useState } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";

import { fetchInvoice } from "../../../_redux/invoices/invoicesActions";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
  ModalProgressBar,
} from "../../../../../../_metronic/_partials/controls";
import { AttachmentList } from "../../../../../../_metronic/_partials/attachments/AttachmentList";
import DOMPurify from "dompurify";
import {HasWriteAccess, IsSuperUser} from "../../../../../../_metronic/_helpers/AccessControlHelpers";
import {INVOICE_MODEL} from "../../../../../../_metronic/_helpers/AppModels";
import axios from "axios";

export function InvoiceSingle({
                                history,
                                match: {
                                  params: { id },
                                },
                              }) {
  const [title, setTitle] = useState("");
  const {user} = useSelector((state) => state.auth);
  const onClickPay = async () => {
      const checkResult = await axios.get(`${process.env.REACT_APP_API_URL}/auth/wallets/check`, {
          params: {
              amount: invoiceToView?.amount,
              branchId: invoiceToView?.branchId,
          }
      })

      if(checkResult.data === false){
          const confirmed = window.confirm(
              'موجودی کیف پول شما کافی نمیباشد. برای شارژ حساب روی دکمه تایید کلیک کنید'
          );

          if (confirmed) {
              window.location.href = 'https://portal.sybt.ir/user-profile';
          }
      }

      if(checkResult.data === true){
          const confirmed = window.confirm(
              `آیا پرداخت مبلغ ${parseInt(invoiceToView?.amount).toLocaleString()} ریال از کیف پول خود را تایید میکنید؟`
          );

          if (confirmed) {
              const payResult = await axios.post(`${process.env.REACT_APP_API_URL}/auth/wallets/issue`, {
                  issueType: 0,
                  userId: user.id,
                  recordId: invoiceToView.id,
                  amount: invoiceToView.amount,
                  branchId: invoiceToView.branchId
              })

              if(payResult.data === true){
                  alert('پرداخت با موفقیت انجام شد');
                  window.location.reload();
              }
          }
      }

  }

  const dispatch = useDispatch();

  const { actionsLoading, invoiceToView } = useSelector(
      (state) => ({
        actionsLoading: state.invoices.actionsLoading,
        invoiceToView: state.invoices.invoiceToView,
      }),
      shallowEqual
  );

  useEffect(() => {
    if (dispatch && id) dispatch(fetchInvoice(id));
  }, [id, dispatch]);

  useEffect(() => {
    if (invoiceToView) setTitle(`فاکتور شعبه ${invoiceToView.branchName}`);
  }, [invoiceToView]);

  const sanitizedDescription = useMemo(() => {
    return DOMPurify.sanitize(invoiceToView?.description || "");
  }, [invoiceToView]);

  return (
      <Card>
        {actionsLoading && <ModalProgressBar />}
        <CardHeader
            title={title}
            dateTime={new Date(invoiceToView?.createDate).toLocaleString("fa-IR")}
        >
          <CardHeaderToolbar>
            <button
                type={"button"}
                className={"btn mr-4"}
                style={{ cursor: "default" }}
            >
              <i className={"fa fa-eye"} />
              <span className={"font-size-h3"} style={{ color: "#6b6b6b" }}>
              {invoiceToView?.viewCount}
            </span>
            </button>
              {(HasWriteAccess(user, INVOICE_MODEL) || IsSuperUser(user)) && (
            <button
                type={"button"}
                onClick={() => history.push(`/accounting/invoices/${id}/edit`)}
                className={"btn btn-primary mr-4"}
            >
              <i className={"fa fa-edit"} />
              ویرایش
            </button>
              )}
              {invoiceToView && invoiceToView?.status === 0 && (
              <button
                  type={'button'}
                  onClick={() => onClickPay()}
                  className={'btn btn-primary mr-4'}>
                  پرداخت از طریق کیف پول
              </button>
              )}
              {invoiceToView && invoiceToView.status === 1 && (
                  <div className={'badge badge-success'}>پرداخت شده</div>
              )}

            <button
                type={"button"}
                onClick={() => history.push("/accounting/invoices")}
                className={"btn btn-light"}
            >
              <i className={"fa fa-arrow-left"} />
              برگشت
            </button>
          </CardHeaderToolbar>
        </CardHeader>
        <CardBody>
          <div className={"mb-5"}>
            <div className={"d-flex flex-column mb-8"}>
              <div>
                <p className={"font-size-h6 mb-1 font-weight-bolder"}>
                  توضیحات فاکتور:
                </p>
                <div
                    className="ml-4"
                    dangerouslySetInnerHTML={{ __html: sanitizedDescription }}
                />
              </div>
                <div>
                    <p className={'font-size-h6 mb-1 font-weight-bolder'}>
                        مبلغ فاکتور:
                    </p>
                    <div className={'ml-4'}>
                        {parseInt(invoiceToView?.amount).toLocaleString()} ریال
                    </div>
                </div>
            </div>
          </div>
          <hr />
          <h4 className={"mb-6"}>پیوست ها:</h4>
          {invoiceToView && !actionsLoading && (
              <AttachmentList model={"Invoice"} recordId={invoiceToView.id} />
          )}
        </CardBody>
      </Card>
  );
}
